import { useContext } from "react";
import { Context } from "./SchedulePlanner";
import styled from "styled-components";
import { useFetchTourGroupsIdsBySpecificDateForSchedule } from "@/reactQueryHooks";
import TourGroupList from "./tour_groups_list/TourGroupList";
import TourGroupLoader from "./TourGroupLoader";
import "react-loading-skeleton/dist/skeleton.css";

const ContentContainer = styled.div`
  overflow: hidden;
  //hide in less than 900px
  @media (max-width: 900px) {
    display: none;
  }
  min-width: 350px;
  max-width: 400px;
`;

//------------------------------------------------------------------------------------

const TourGroupsListWrapper = () => {
  const { tourGroupsDate } = useContext(Context);

  const { data: tourGroupIdsBySpecificDate, isFetching: isFetchingIds } =
    useFetchTourGroupsIdsBySpecificDateForSchedule(tourGroupsDate);

  const tourGroupIds = tourGroupIdsBySpecificDate?.map(
    (tourGroup: { _id: string }) => tourGroup._id
  );

  return (
    <ContentContainer>
      {isFetchingIds && <TourGroupLoader />}
      {!isFetchingIds && <TourGroupList tourGroupIds={tourGroupIds} />}
    </ContentContainer>
  );
};

export default TourGroupsListWrapper;
